export const SCREEN_TABLET = 768;
